export const CACHE_KEY_USER_EDIT = 'user-edit';
